import axios from "axios";
import { Markup } from "interweave";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ReactPlayer from "react-player";
import { serverInfo } from "../../../../../App";
import noImage from "../../../../../assets/images/settings/no-image.png";
import PriceTag from "../../../../../assets/images/tagPrice.PNG";
import LoaderPost from "../../../../Reuseable/LoaderPost";
import "./SouvenirMain.css";
import StarShowcaseModal from "./StarShowcaseModal/StarShowcaseModal";
// import noImage from "../../../../../../";

const SouvenirPaymentList = () => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const [souviner, setCheckSouvenir] = useState({});
  const [souvinerView, setSouvinerView] = useState({});
  const [userPaymentSouvenir, setUserPaymentSouvenir] = useState([]);
  const [loading, setloading] = useState(true);
  // const [modalShowl, setModalShowl] = useState(false);

  const [show, setShow] = useState(false);


  const handleView = (applyId) => {
    setShow(true);

    axios.get(`/api/star/souvenir/apply/view/${applyId}`).then((res) => {
      if (res.data.status === 200) {
        setSouvinerView(res.data?.souvinerView);
      }
    });
  };

  useEffect(() => {
    axios.get("/api/star/souviner/check").then((res) => {
      if (res.data.status === 200) {
        setCheckSouvenir(res.data?.getSouviner);
        // setStatus(res.data.action)
        setloading(false);
      }
    });
    axios.get("/api/star/souvenir/register/list").then((res) => {
      if (res.data.status === 200) {
        setUserPaymentSouvenir(res.data?.userPaymentSouvenir);
      }
    });
  }, []);
console.log('======> ',souviner);
  return (
    <>
      {loading ? (
        <LoaderPost />
      ) : (
        <>
          <div className="row ">
            <div className="col-md-12 col-lg-7 mb-3">
              <div className="card card-bg p-2">
                <img
                  src={
                    souviner?.banner ? imageCdnUrl + souviner?.banner : noImage
                  }
                  alt=""
                  className="BannerAGN img-fluid w-100"
                  maxHeight="450px"
                />
              </div>
            </div>

            <div className=" col-md-5 mb-3">
              <div className="card card-bg head-line  mb-2">
                <div className="text-light d-flex justify-content-center p-2">
                  <div className="faTrophy">
                    <i className="fas fa-trophy"></i>
                  </div>
                  <h4 className="mx-3 text-white p-2">{souviner?.title}</h4>
                </div>
              </div>
              <p className="text-light  card card-bg p-2">
                <Markup content={souviner?.instruction} />
              </p>
              {/* <div className="card card-bg px-3 py-4">
                  <h4 className="text-light">{souviner?.name}</h4>
                  <p className="text-light pt-1">
                  </p>
                </div> */}
              <div className="col-sm-12 col-md-12 col-lg-6">
                <div
                  className="d-flex justify-content-center border border-warning bg-dark mt-3 p-2 buTon-a "
                  style={{ width: "100%" }}
                >
                  <span>
                    <img src={PriceTag} alt="" className="PriceTage" />
                  </span>
                  <div className=" mx-2 ">
                    <span className="text-light buTon-ab ">Cost</span>
                    <br></br>
                    <span className="text-info fw-bold buTon-abc">
                      {souviner?.price} $
                    </span>
                  </div>
                </div>
              </div>
            </div>
           
          </div>

          <div className="mt-3 row">
            <div className="col-md-12 mb-3">
              <div className="row w-100 LeftGNA m-0">
                <div className="NotifyOver w-100 ">
                  <table className="w-100 my-3 NotifyTabletd ">
                    <thead style={{ borderBottom: "2px solid gold" }}>
                      <tr className="NotifyTable mx-3">
                        <td className="Notifytdx lNTS"> SL. </td>
                        <td className="Notifytdx"> Image </td>
                        <td className="Notifytdx "> Name </td>
                        <td className="Notifytdx ">Mobile No</td>
                        <td className="Notifytdx ">Country</td>
                        <td className="Notifytdx ">State</td>
                        <td className="Notifytdx ">City</td>
                        <td className="Notifytdx rNTS">Action</td>
                      </tr>
                    </thead>
                    <tbody>
                      {userPaymentSouvenir?.map((data, index) => (
                        <tr className="NotifyTable mx-3" key={index}>
                          <td className="Notifytdx ">{index + 1}</td>
                          <td className="Notifytdx ">
                            {" "}
                            <img
                              src={
                                data?.image != null
                                  ? imageCdnUrl + data?.image
                                  : noImage
                              }
                              className="NotifyAimg"
                              alt="profile"
                            />{" "}
                          </td>
                          <td className="Notifytdx ">{data?.name}</td>
                          <td className="Notifytdx ">{data?.mobile_no}</td>
                          <td className="Notifytdx ">{data.country?.name}</td>
                          <td className="Notifytdx ">{data.state?.name}</td>
                          <td className="Notifytdx ">{data.city?.name}</td>
                          <td className="Notifytdx ">
                            <i
                              className="fa fa-eye mx-3 sovenirRegisterView"
                              title="View Registered"
                              onClick={() => handleView(data?.id)}
                            ></i>
                            {/* <i className="fa fa-download ml-3 sovenirPayment" title="Approved Registered" onClick={() => handleUserOrder(data?.id)}></i> */}
                            {/* <i className="fa fa-trash mx-3 sovenirRegisterDecline" title="Decline Registered" onClick={() => handleRegisterDecline(data?.id)}></i> */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

           
          </div>
          <StarShowcaseModal
            souvenir={souvinerView}
            show={show}
            onHide={() => setShow(false)}
          />
        </>
      )}
    </>
  );
};

export default SouvenirPaymentList;
